@import '~style-sheet-helpers/core.less';

.phone-verify-modal-wrapper {
  width: 375px;
}

.body {
  height: 225px;
}

.title-text {
  font-size: 20px;
  font-weight: @bold;
}

.subtitle-text {
  margin-top: 10px;
  font-size: 13px;
  line-height: 16px;
}

.footer {
  button:first-of-type {
    margin-right: 10px;
  }
}
